<template>
  <div class="vx-card">
    <div class="vx-card__body card-body">
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <data-grid
            ref="grid"
            stripe
            :data-source="gridDataSource"
            :search-data="gridSearchData"
            :columns="[
              { title: $t('Title') },
              { title: $t('GenericProduct') },
              { title: $t('Action') },
            ]"
            v-has-permission="permission318"
          >
            <template slot-scope="{ row }">
              <td style="width: 45%">
                {{ row.name }}
              </td>
              <td style="width: 25%">
                {{ row.genericProductName }}
              </td>

              <td style="width: 20%">
                <vs-button
                  color="primary"
                  type="border"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="bordered-btn"
                  @click.prevent="segmentPopup(row)"
                  >{{ $t("ChooseSegment") }}</vs-button
                >
              </td>
            </template>
          </data-grid>
        </div>
      </div>
      <segment-popup
        :show="showSegmentPopup"
        :actualProductId="actualProductId"
        @finish="onfinish"
        @close="closeSegmentPopup"
      ></segment-popup>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import SegmentPopup from "./SegmentPopup.vue";
export default {
  components: {
    DataGrid,
    SegmentPopup,
  },
  data() {
    return {
      permission318: "GetProductsThatNotAssignToAnySegment",
      actualProductId: "",
      gridDataSource: {
        type: "app",
        service:
          "Sales/api/SegmentQuery/products-that-not-assign-to-any-segments",
      },
      gridSearchData: {},
      showSegmentPopup: false,
    };
  },
  methods: {
    ...mapActions({
      fetchSearch: "sale/fetchActualSearch",
    }),
    closeSegmentPopup() {
      this.showSegmentPopup = false;
    },
    onfinish() {
      this.closeSegmentPopup();
      this.$refs.grid.renderGrid();
    },
    segmentPopup(model) {
      this.actualProductId = model.id;
      this.showSegmentPopup = true;
    },
  },
};
</script>
